import { render, staticRenderFns } from "./Segnalazioni.vue?vue&type=template&id=987eaa34&scoped=true&"
import script from "./Segnalazioni.vue?vue&type=script&lang=js&"
export * from "./Segnalazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987eaa34",
  null
  
)

export default component.exports